import { render, staticRenderFns } from "./SessionsTraining.vue?vue&type=template&id=4088432b"
import script from "./SessionsTraining.vue?vue&type=script&lang=js"
export * from "./SessionsTraining.vue?vue&type=script&lang=js"
import style0 from "./sessions-training.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports